import React, {useEffect, useState} from "react";
import PageHeader from "../../components/organisms/PageHeader";
import Btn from "../../components/atoms/Btn";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import styled from "styled-components";
import {device} from "../../assets/styles/media";
import decodeEntities from "../../util/decodeEntities";
import AttachFile from "../../components/molecules/AttachFile";
import request from "../../config/Axios";

const Category = styled.p`
    display: block;
    color: #ed8e0c;
    letter-spacing: -0.3px;
    font-weight: 500;

`;
const BoardTitle = styled.p`
    display: block;
    margin-top: 8px;
    font-size: 28px;
    line-height: 30px;
    letter-spacing: -0.5px;
    font-weight: bold;

    ${device.mobile} {
        font-size: 18px;
    }
`;
const BoardDesc = styled.p`
    display: block;
    margin: 20px 0 20px 0;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.4px;
    color: #4a4a4a;
    padding-bottom: 20px;
    border-bottom: 1px solid #eaeaea;

    ${device.mobile} {
        margin: 0;
        font-size: 13px;
    }
`;

const Contents = styled.div`
    padding: 60px 0;
    text-align: center;
    max-width: 900px;
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;

    img {
        max-width: 900px ;
        height: auto !important;
    }
    ${device.mobile} {
        max-width : 100vw;
        width: 100%;
        padding: 30px 0;
        
        img {
            width: 100% !important;
            height: auto !important;
        }
    }

`;

const Detail = () => {
    const { boardType, id } = useParams();

    const location = useLocation();
    const navigate = useNavigate();
    const basePath = location.pathname.replace(/\/[^/]+$/, "");
    const [navList, setNavList] = useState([]);
    const [content, setContent] = useState({});

    useEffect(() => {
        (async () => {
            try {
                let response;
                if(location.pathname.startsWith("/program/museum")){
                    // boards/museum/special/posts/577
                    response = await request.get(`boards/museum/${boardType}/posts/${id}`);
                }else{
                    response = await request.get(`boards/${boardType}/posts/${id}`);
                }
                if(response.data.code === 0){
                    setContent(response.data.data.post);
                }

            } catch (err) {
                console.error('api 호출 중 에러 발생:', err);
            }
        })();
    }, [boardType,id]);

    useEffect(() => {
        const list = location.pathname.includes("/museum")
            ? [
                {name: "상설 전시", link: "/program/museum/permanent"},
                {name: "특별 전시", link: "/program/museum/special"},
                {name: "지난 전시", link: "/program/museum/past"},
            ]
            : location.pathname.includes("/program") ?
                [
                    {name: "강아지숲 박물관", link: "/program/museum"},
                    {name: "상설프로그램", link: "/program/permanent"},
                    {name: "특별프로그램", link: "/program/special"},
                    {name: "도그 스포츠", link: "/program/sports"},
                ]
                : [
                    {name: "공지", link: "/notice/announcement"},
                    {name: "캠페인", link: "/notice/campaign"},
                    {name: "강아지숲 이야기", link: "/notice/dstory"},
                    {name: "자주하는 질문", link: "/notice/faq"},
                ];
        setNavList(list);
    }, [location.pathname]);
    return (
        <>
            {content && content.category ?  <>
                <PageHeader
                    bTitle={location.pathname.includes("/program") ? "프로그램" : "알림"}
                    detail={content.category}
                    desc={content.category + " 안내해 드립니다."}
                    list={navList}
                    top={true}
                />
                <Category>{content.category}</Category>
                <BoardTitle>{decodeEntities(content.subject)}</BoardTitle>
                <BoardDesc>{decodeEntities(content.descLine)}</BoardDesc>
                <Contents>
                    <div style={{width:"100%",height:"auto"}} dangerouslySetInnerHTML={{__html: content.content}}/>
                    {/* 파일 존재 유무 확인*/}
                    {content.files && <AttachFile files={content.files}/> }
                    <Btn text={"목록보기"}
                         onClick={() => navigate(basePath)}
                    />
                </Contents>
            </> : <Contents> 존재하지 않는 게시물입니다. </Contents>}

        </>
    )
        ;
};

export default Detail;
